import { useAtom } from "jotai";
import { useRef } from "react";

import { $authStatus } from "../../internal/authenication/authStatus.atom";
import { $redirectPath } from "../../internal/authenication/redirect.atom";

// This is used when we are trying to redirect after
// a user is logging in or logging out.
export const useAuthRedirect = () => {
	const [redirect, setRedirect] = useAtom($redirectPath);

	return {
		redirect,
		setRedirect,
	};
};

export const useAuthStatus = () => {
	const [authStatus, setAuthStatus] = useAtom($authStatus);
	const authStatusRef = useRef(authStatus);
	authStatusRef.current = authStatus;

	return {
		authStatus,
		authStatusRef,
		setAuthStatus,
	};
};
